import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { MessageService } from '@services/message.service';
import { MovimentacaoCaixaApiService } from '../../../services/movimentacao-caixa-api.service';

export interface MoverLancamentoDialogData {
  lancamentoIds: number[];
  data: Date;
}

@Component({
  selector: 'app-mover-lancamento-dialog',
  standalone: false,
  templateUrl: './mover-lancamento-dialog.component.html',
  styleUrl: './mover-lancamento-dialog.component.scss'
})
export class MoverLancamentoDialogComponent {

  title: string = 'Mover para outro lote';

  lancamentoIds: number[];
  data: Date;
  nome: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) dialogData: MoverLancamentoDialogData,
    private movimentacaoCaixaApiService: MovimentacaoCaixaApiService,
    private messageService: MessageService,
    private dialogRef: MatDialogRef<MoverLancamentoDialogComponent>
  ) {
    this.lancamentoIds = dialogData.lancamentoIds;
    this.data = new Date(dialogData.data);
  }

  public salvarClick(): void {
    if (!this.data) {
      this.messageService.showToastWarning('A data do lote não pode ser vazia');
      return;
    }
    if (!this.nome?.trim()) {
      this.messageService.showToastWarning('O nome do lote não pode ser vazio');
      return;
    }

    this.movimentacaoCaixaApiService.moverLancamentoDeLote({
      lancamentoIds: this.lancamentoIds,
      data: this.data,
      nomeLote: this.nome
    }).subscribe(() => {
      const msg = this.lancamentoIds.length === 1
        ? 'Lançamento movido com sucesso'
        : `${this.lancamentoIds.length} lançamentos movidos com sucesso`;
      this.messageService.showToastSuccess(msg);
      this.dialogRef.close(true);
    });
  }
}
